// src/components/icons/FireIcon.tsx
"use client";

import React from "react";

interface FireIconProps {
  size?: number;
  className?: string;
}

const FireIcon: React.FC<FireIconProps> = ({
  size = 24,
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
    >
      {/* شعله بیرونی - قرمز داغ */}
      <path
        d="M15.362 5.214A8.252 8.252 0 0 1 12 21 8.25 8.25 0 0 1 6.038 7.047 8.287 8.287 0 0 0 9 9.601a8.983 8.983 0 0 1 3.361-6.867 8.21 8.21 0 0 0 3 2.48Z"
        fill="#D84315"
      />
      {/* شعله درونی - زرد روشن */}
      <path
        d="M12 18a3.75 3.75 0 0 0 .495-7.468 5.99 5.99 0 0 0-1.925 3.547 5.975 5.975 0 0 1-2.133-1.001A3.75 3.75 0 0 0 12 18Z"
        fill="#F6C860"
      />
      {/* متن LIT بسیار کوچک در مرکز آتش */}
      <text
        x="12.2"
        y="20"
        textAnchor="middle"
        fontSize="2"
        fill="#ffffff"
        fontFamily='"Lato", "Noto Sans", "Helvetica", "Segoe UI", sans-serif'
        fontWeight="bold"
        pointerEvents="none"
      >
        LIT
      </text>
    </svg>
  );
};

export default FireIcon;
